<template>
  <div class="app-hang-dailog" 
    v-if="!removed" 
    :class="{show: shouldShow, closing: closeInProcess}">
    <div class="app-hang-dailog-container">
      <div class="dailog-title" v-if="showTitle">
        <div class="main">
          <h3>{{title}}</h3>
        </div>
        <div class="buttons">
          <button class="clean box" v-if="showCancel" @click="onCancel">Cancel</button>
          <button class="clean fullcolor" v-if="yesText" @click="onYes">{{yesText}}</button>
        </div>
      </div>
      <div class="dailog-content">
        <slot></slot>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: String,
    showTitle: {
      type: Boolean,
      default: true
    },
    showCancel: {
      type: Boolean,
      default: true
    },
    yesText: {
      type: String,
      default: "Yes"
    },
    payload: Object,
    show: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      closeInProcess: false,
      shouldShow: false,
      removed: true,
      timeoutId: null,
    }
  },
  watch: {
    'show'(toShow, from) {
      if (toShow && !this.shouldShow) {
        this.doShow()
      } else if (!toShow && this.shouldShow) {
        this.doClose()
      }
    }
  },
  mounted () {
    if (this.show && !this.shouldShow) {
      this.doShow()
    }
  },

  methods: {
    doClose () {
      this.shouldShow = false
      this.closeInProcess = true
      this.$emit("onClosing", this.payload)

      this.timeoutId = setTimeout(() => {
        this.closeInProcess = false
        this.removed = true
        this.$emit("onClose", this.payload)
      }, 750) // Animation duration

    },

    doShow () {
      if (this.closeInProcess) {
        clearTimeout(this.timeoutId)
        this.closeInProcess = true
      }
      this.removed = false
      setTimeout(() => {
        this.shouldShow = true
      }, 50)
    },

    onCancel () {
      this.$emit("onCancel", this.payload)
      this.doClose()
    },

    onYes () {
      this.$emit("onYes", this.payload)
      this.doClose()
    },

    onBoxClick (event) {
      event.stopPropagation()
    },

    onContainerClick (event) {
      this.onCancel()
    }
  
  }
}
</script>
